const packageIdRegex = /(https:\/\/)?(www.)?(github)?(.com|.org)?\/?[^/;]+\/[^/\n;]+/;
const packageIdRemovalRegex = /(https:\/\/)?(www.)?(github)?(.com|.org)?\/?/;

export default function getPackageId(packageRawId) {
    const matches = packageRawId.match(packageIdRegex);
    if (!matches || !matches[0]) return;
    return matches[0].replace(packageIdRemovalRegex, '');
};